const en = {
    login: "Login",
    logout: "Log out",
    signIn: "Sign in",
    signOut: "Sign out",
    profile: "Profile",
    settings: "Settings",
    digiAirMenuWaiterLogin: "DigiAirMenu Waiter Login",
    appLogoAlt: "digiAirMenu logo",
    username: "Username",
    password: "Password",
    pinCode: "PIN code",
    yourAuthenticationFailed: "Your authentication failed",
    addDAMToHomeScreen: "Add DigiAirMenu to your home screen",
    addToHomeScreen: "Add to home screen",
    installDAM: "Install DAM",
    language: "Language",
    chooseLanguage: "Choose language",
    pageNotFound: "Page not found",
    backToDashboard: "Back to dashboard",
    transferToDemo: "Transfer to demo",
    transferToLive: "Transfer to live",
    currentTable: "Current table",
    table: "Table",
    tables: "Tables",
    order: "Order",
    orders: "Orders",
    option: "Option",
    additive: "Additive",
    options: "Options",
    additives: "Additives",
    empty: "Empty",
    row: "Row",
    count: "count",
    step: "step",
    title: "Title",
    untitledItem: "Untitled",
    createdAt: "Created at",
    free: "Free",
    freeItems: "free items",
    items: "items",
    item: "item",
    itemsCountOfAll: "{{payCount}} of {{maxCount}}",
    minimum: "minimum",
    maximum: "Maximum",
    min: "min",
    max: "max",
    all: "All",
    unitPrice: "Unit price",
    email: "Email",
    print: "Print",
    printingFailed: "Printing failed!",
    checkoutPrintDataUnavailable: "Payment receipt data is not available for printing",
    printUsingExternalDevice: "Print using external device",
    orderDetails: "Order details",
    noOrders: "No orders",
    noOrdersAdded: "No orders added",
    noAddedItems: "No items have been added",
    loading: "Loading",
    createOrSelectOrderAfterSelectingTable: "First select a table and then create/select an order",
    createOrSelectOrderFirst: "Create/select an order at the first",
    customFood: "Custom food",
    customFoods: "Custom foods",
    normalFoodOrDrink: "normal food/drink",
    customMenuItems: "Custom menu items",
    sentToKitchen: "Sent to kitchen",
    sendToKitchen: "Send to kitchen",
    orderDelivered: "Order delivered",
    orderDeliveredConfirmation: "Are you sure this order has been delivered?",
    selectItemsForSendingToKitchen: "Select items for sending to kitchen",
    type: "type",
    status: "status",
    ItemDetailsAndStatus: "Item details / status",
    description: "description",
    typeAnythingYouNeed: "Type anything you need",
    paid: "paid",
    unpaid: "unpaid",
    partiallyPaid: "Partially paid",
    pending: "Pending",
    canceled: "Canceled",
    created: "Created",
    accepted: "Accepted",
    arrival: "Arrival",
    late_arrival: "Late arrival",
    late_pickup: "Late pickup",
    request_new_driver: "Request new driver",
    shipment_destroyed: "Shipment destroyed",
    address_not_found: "Address not found",
    completed: "Completed",
    late_completed: "Late completed",
    isPaid: "Is paid",
    total: "Total",
    editOrderItem: "Edit order item",
    chooseTable: "Choose Table",
    pickup: "Pickup",
    suspended: "Suspended",
    processing: "Processing",
    rejected: "Rejected",
    delivered: "Delivered",
    ordersList: "Orders List",
    showOlderOrders: "Show older orders",
    showHistory: "Show history",
    showCanceledOrders: "Show canceled orders",
    showDeliveredOrders: "Show delivered orders",
    showPaidOrders: "Show paid orders",
    listOfOrders: "List of orders",
    listOfolderOrRejectedOrdersTitle: "Older/Rejected",
    addNewOrder: "Add new order",
    ordering: "Ordering",
    availableFoods: "Available Foods",
    searchByTableName: "Search by table name",
    Layout: "Layout",
    gridView: "Grid view",
    listView: "List view",
    Filters: "Filters",
    availableItems: "Available Items",
    searchByFoodName: "Search by food name",
    allCategories: "All Categories",
    noCategories: "No Categories",
    addFood: "Add Food",
    editManualItem: "Edit manual item",
    addManualItem: "Add manual item",
    manualItem: "Manual item",
    manualItems: "Manual items",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "Are you sure you want to convert order <1>{{orderId}}</1> to a demo order?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "Are you sure you want to convert order <1>{{orderId}}</1> to a live order?",
    areYouSureYouWantToSwitchToLiveMode: "Are you sure you want to switch to live mode?",
    areYouSureYouWantToSwitchToDemoMode: "Are you sure you want to switch to demo mode?",
    areYouWantDeleteThisItem: "Are you sure you want to delete this item?",
    areYouWantCancelOrder: "Are you sure you want to cancel this order?",
    getEmailLabel: "Please enter your email",
    enterValidEmailErr: "Please enter a valid email.",
    sendEmail: "Send email",
    send: "Send",
    sendReceiptInfo: "Send receipt details",
    resendPaymentLink: "Resend payment link",
    sendMenuSms: "Send Menu Link",
    sendMenuLinkBySms: "Send menu link via SMS",
    menuLinkSentSuccessfully: "Menu link sent successfully",
    paymentLinkResentSuccessfully: "Payment link sent successfully",
    receiverEmail: "Receiver email",
    receiverPhone: "Receiver phone",
    receiverEmailPlaceholder: "example@email.com",
    emailIsRequired: "Email is required",
    phoneNumberIsRequired: "Phone number is required",
    emailOrPhoneIsRequired: "Email or phone number is required",
    invalidEmailFormat: "Invalid email format",
    iUnderstand: "I understand",
    no: "No",
    yes: "Yes",
    cancel: "Cancel",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    add: "Add",
    preview: "Preview",
    changeTable: "Change table",
    saveChanges: "Save changes",
    confirm: "Confirm",
    unselectAll: "Unselect all",
    selectAll: "Select all",
    selected: "selected",
    reset: "Reset",
    clear: "Clear",
    mobileKeyboard: "Mobile keyboard",
    externalDeliveryOrder: "External delivery order",
    externalDeliveryOrderDescription: "This order must be accepted before processing",
    waiterDraftOrder: "Waiter-created order",
    waiterDraftOrderDescription: "You can still edit this order. Confirm it when everything is final.",
    accept: "Accept",
    acceptOrder: "Accept order",
    confirmOrder: "Confirm order",
    completeOrderSetup: "Complete order setup",
    completeOrderSetupDialogTitle: "Complete delivery details and finalize order timing",
    acceptOrderDialogTitle: "Accepting this order will start preparation and notify the kitchen",
    confirmOrderDialogTitle: "Confirming this order will lock changes and start preparation",
    acceptOrderExternalDescription: "This order was placed externally. Accept it to start preparation, or reject it if you cannot fulfill it.",
    confirmOrderWaiterCreatedDescription: "This order was created by waiter. Review and confirm it when all items are ready.",
    acceptOrderWaiterCreatedDescription: "This order was created by waiter. Accept it to lock changes and start preparation.",
    editingLockedForCustomerOrder: "Editing is locked for customer orders.",
    editingLockedForRejectedOrder: "Editing is locked because this order was rejected.",
    editingLockedCustomerOrderAfterAcceptance: "Editing is locked for customer orders after acceptance.",
    editingLockedAfterConfirmation: "Editing is locked after order confirmation.",
    editingDoneOrderItemLocked: "Items that are already done can no longer be changed.",
    editingPaidOrderItemLocked: "Paid items can no longer be changed.",
    editingPendingPaymentOrderItemLocked: "This item cannot be changed while its payment is being processed.",
    editingSentToKitchenItemLockedByPermission: "You do not have permission to change items that have already been sent to the kitchen.",
    rejectOrder: "Reject order",
    rejectOrderConfirm: "Are you sure you want to reject this order?",
    acceptOrderPickupTimeHelperText: "You can delay the pickup time by up to <1>30 minutes</1>",
    pleaseEnterPickupTime: "Please enter a pickup time",
    addToOrders: "add to orders",
    cancelThisOrder: "Cancel this order",
    cancelOrder: "Cancel order",
    orderModeChangedToDemoInJSX: "The desired order mode was changed to demo mode with the title '<1>Order {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "The desired order mode was changed to live mode with the title '<1>Order {{targetOrderId}}</1>'.",
    checkoutHasPaidByPosInJSX: "The <1>Checkout</1> with id <3>{{checkout_id}}</3> from <5>order {{order_id}}</5> has successfully paid through POS.",
    demo: "Demo",
    demoModeIsActive: "Demo mode is active",
    demoModeAlertMessage: "Demo Mode is intended for training and testing purposes only. The restaurant operator is solely responsible for the use of the system and compliance with all applicable legal regulations while Demo Mode is active.",
    normal: "Normal",
    showOrderInTargetMode: "Show order in {{targetMode}} Mode",
    showOrder: "Show order",
    openOrderInBackground: "<0>Open</0> <1>(in background)</1>",
    incomingOrderNotificationTitle: "New order received",
    incomingOrderNotificationDescription: "A customer order has arrived. Use the button below to open it in background without closing this modal.",
    yesDeleteIt: "Yes, Delete it",
    pay: "Pay",
    payment: "Payment",
    payments: "Payments",
    payReport: "Pay report",
    paymentOf: "Payment of",
    checkoutOperation: "Checkout operation",
    itemsToPay: "Items to pay",
    price: "Price",
    basicPrice: "Basic price",
    totalPrice: "Total price",
    baseAmount: "Base amount",
    paidPrice: "Paid price",
    paidBy: "Paid by",
    discount: "Discount",
    discountAmount: "Discount amount",
    tipPrice: "Tip price",
    totalWithTip: "Total with tip",
    amountToPay: "Amount to pay",
    paymentAmount: "Payment amount",
    paymentsIncludingDiscounts: "Payments including discounts",
    paymentsExcludingDiscounts: "Payments excluding discounts",
    paymentsTakingIntoAccountTheirDiscount: "Payments taking into account their discount",
    paymentsRegardlessOfTheirDiscount: "Payments regardless of their discount",
    openPaymentsStatistics: "Statistics of open payments",
    discountCannotBeLessThanZero: 'The amount of discount cannot be less than "0"',
    discountCannotBeNegative: "The discount amount cannot be negative",
    discountCannotBeMoreThanHundredPercent: 'The amount of discount cannot be more than "100%"',
    discountCannotBeMoreThan: 'The discount amount cannot be more than {{price}}',
    theValueMustBeMoreThan: "The value must be more than {{price}}",
    theValueMustBeMoreThanBaseAmount: "The value must be more than Base Amount",
    valueMustBeLessThanOrEqualToMessage: "The value must be less than or equal to {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "The value must be greater than 0",
    tip: "Tip",
    tipAmount: "Tip amount",
    tipCannotBeNegative: "The tip amount cannot be negative",
    payByCreditCard: "Pay by Credit Card",
    payInCash: "Pay in Cash",
    cardTransfer: "Card transfer",
    checkout: "Checkout",
    transaction: "Transaction",
    noTransactionHasBeenMade: "No transaction has been made",
    backToTransactionsList: "Back to transactions list",
    transactionsHistory: "Transactions history",
    transactionDetails: "Transaction details",
    transactionId: "Transaction Id",
    transactionHasBeenSentToYourEmail: "The transaction has been sent to your email",
    paymentType: "Payment type",
    paymentStatus: "Payment status",
    ordersPrice: "Orders price",
    totalAmount: "Total amount",
    updatedAt: "Updated at",
    fromTime: "From time",
    toTime: "To time",
    backToOrders: "Back to orders",
    tablesList: "Tables list",
    backToTablesList: "Back to tables list",
    showDetails: "Show details",
    receiptDetailsPage: "Receipt details page",
    checkoutQrCodeAlt: "Checkout QR code",
    vat: "VAT",
    net: "Net",
    tax: "Tax",
    gross: "Gross",
    sendingEmailFailed: "Sending email failed!",
    paymentFailed: "Payment failed",
    openPayments: "Open payments",
    Open_Payments: "Open-Payments",
    openPaymentsReport: "Open payments report",
    report: "Report",
    openPaymentStatistics: "Open payment statistics",
    allOrderItemsHaveBeenPaid: "All items on this order have been paid",
    noItemsHaveBeenAddedInThisOrder: "No items have been added in this order",
    thisItemPaymentIsAwaitingConfirmation: "This item's payment is awaiting confirmation",
    yourOrderPaymentIsAwaitingConfirmation: "This order has a payment awaiting confirmation",
    editableInTime: "Editable in {{minutes}}m {{seconds}}s",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "This item has been paid through POS and is awaiting payment confirmation",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Your Order has been paid through POS and is awaiting payment confirmation",
    generalSettings: "General settings",
    customItems: "Custom Items",
    printMethod: "Print method",
    singlePrintMethodDescription: "Only one print method is active at a time",
    printMethodBrowser: "Browser print dialog",
    printMethodBluetooth: "Bluetooth printer",
    printMethodUsb: "USB printer (Experimental)",
    printMethodExternal: "External printer / app",
    bluetoothUnavailable: "Bluetooth is not available in this browser or device",
    bluetoothSecureContextRequired: "Bluetooth printing requires HTTPS or localhost",
    bluetoothPrinterNotSupported: "The selected Bluetooth printer is not supported",
    noBluetoothPrinterSelected: "No Bluetooth printer was selected",
    noCompatibleBluetoothPrinterFound: "No compatible Bluetooth printer was found or selected. Browsers usually discover only BLE/GATT printers, so classic Bluetooth models like Epson TM-m30 may not appear here",
    bluetoothAutoPrintRequiresSelection: "Select a Bluetooth printer manually once before automatic printing can be used",
    bluetoothPrintingNotSupported: "Bluetooth printing is not supported on this browser or device",
    usbUnavailable: "USB is not available in this browser or device",
    usbSecureContextRequired: "USB printing requires HTTPS or localhost",
    noCompatibleUsbPrinterFound: "No compatible USB printer was found or selected",
    usbAccessDenied: "The browser or operating system denied access to the selected USB printer. Close other printer apps and check system USB permissions, then try again",
    usbAutoPrintRequiresSelection: "Select a USB printer manually once before automatic printing can be used",
    usbPrintingNotSupported: "USB printing is not supported for the selected device",
    printerSize: "Printer Size",
    useExternalPrinter: "Use external printer",
    bluetoothPrinterDetails: "you can send print to bluetooth printer devices or disable it to select a printer from the available connected printer to this device",
    usbPrinterDetails: "best-effort support for ESC/POS-compatible USB printers on desktop Chrome or Edge. You may need to select the printer once manually before automatic printing can use it. On Windows, the printer may also need Vendor Class mode and a WinUSB-compatible driver before it appears in the browser list",
    externalPrinterDetails: "you can send print to external printer devices which connected to app or disable it to select a printer from the available connected printer to this device",
    autoPrint: "Auto print",
    autoPrintDescription: "Automatically print after accepting an order or after receiving a paid-order websocket event",
    autoPrintUnavailableForBrowserDescription: "Automatic printing is unavailable when using the browser print dialog",
    browserPrintMethodNotice: "The browser print dialog always requires confirmation, so receipts cannot be printed automatically",
    selectAllPayablesByDefault: "Select all payables by default",
    selectAllPayablesByDefaultOnThePaymentPage: "Select all payables by default on the payment page",
    virtualKeyboard: "Virtual keyboard",
    virtualKeyboardDescription: "Use the in-app keyboard on supported form fields",
    virtualKeyboardInfoLabel: "Keyboard help",
    virtualKeyboardDisableHint: "If you prefer your device keyboard, you can turn this keyboard off in <0>Settings</0>.",
    delivery: "Delivery",
    deliveryAddress: "Delivery Address",
    deliveryDetails: "Delivery details",
    addDeliveryDetails: "Add delivery details",
    editDeliveryDetails: "Edit delivery details",
    createDelivery: "Create Delivery",
    fullAddress: "Full Address",
    postalCode: "Postal",
    houseNumber: "House Number",
    served: "Served",
    doorNumber: "Door Number",
    apartmentEntrance: "Apartment Entrance",
    floor: "Floor",
    extraAddressDetails: "Extra Address Details",
    fullName: "Full Name",
    dialCode: "Dial Code",
    phoneNumber: "Phone Number",
    contactInformationAtPickup: "Receiver contact information",
    recommended: "recommended",
    deliverySummary: "Delivery Summary",
    Error: "Error",
    unexpectedErrorOccurred: "An error has occurred",
    distance: "Distance",
    duration: "Duration",
    minutes: "Minutes",
    deliveryPrice: "Delivery price",
    deliveryFee: "Delivery fee",
    itemsPrice: "Items Price",
    totalReceipt: "Total Receipt",
    successfulDeliveryRegistration: "Successful delivery registration",
    successfulSendDelivery: "Successful send delivery",
    customer: "Customer",
    withDelivery: "With Delivery",
    deliveryItem: "Delivery Item",
    pickupDetails: "Pickup details",
    pickupDate: "Pickup date",
    pickupTime: "Pickup time",
    pickupDatetime: "Requested pickup date/time",
    pickupTimeLabel: "Pickup time ({{format}})",
    pickupTimeBaseLabel: "Pickup base time",
    pickupTimeFinalLabel: "Pickup final time",
    dropOffTime: "Drop-off time",
    requestedPickupDatetime: "Current requested pickup date/time",
    timePickerHour: "Hour",
    timePickerMinute: "Minute",
    toggleTimeList: "Toggle time list",
    pickupTimeInitialShort: "Base",
    orderTiming: "Order timing",
    maximumSelectableFreeCountHint: "Maximum number that can be selected for free",
    minimumSelectableCountHint: "Minimum selectable number",
    maximumSelectableCountHint: "Maximum selectable number",
    maximumSelectedItemsReached: "The number of selected items has reached its maximum",
    changePickupTime: "Change pickup time",
    pickupTimeAllowedRangeHint: "For {{date}}, pickup time can be selected from {{start}} to {{end}}.",
    pickupDatetimeNotSetHint: "No pickup date/time has been set yet. You can choose any pickup time.",
    pickupDatetimeLimitedDelayHint: "This requested pickup date/time can be delayed by up to <1>30 minutes</1> while the order is still pending acceptance.",
    pickupDatetimeLockedHint: "A pickup date/time is already set for this order.",
    pickupTimeEditableOnlyWhenSuspended: "Pickup time can only be changed while the order is in suspended status.",
    pleaseEnterPickupDate: "Please enter a pickup date",
    pickupDateMustBeTodayOrTomorrow: "Pickup date must be today or tomorrow for waiter-created orders.",
    normalOrderCreationUnavailableTitle: "Normal orders are currently unavailable",
    normalOrderCreationClosedAllDay: "The restaurant is closed on this day, so orders cannot be created.",
    normalOrderCreationClosedAtThisTime: "The restaurant is currently closed. Orders can be created during opening hours: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "No valid {{orderType}} time is available within the restaurant opening hours for the currently allowed dates.",
    pickupDateOutsideOpeningHours: "The selected date is outside the allowed opening days for {{orderType}} orders.",
    pickupTimeOutsideOpeningHours: "The selected time is outside the allowed opening hours for {{orderType}} orders.",
    openingHoursSelectableRangeHint: "For {{date}}, {{orderType}} time can be selected from {{start}} to {{end}}.",
    openingHoursClosedDayHint: "{{date}} is closed for {{orderType}} orders.",
    openingHoursClosedDayCalendarHint: "Closed for this order type",
    openingHoursDisabledDatesHint: "Only dates with at least one available {{orderType}} time within the restaurant opening hours can be selected.",
    openingHoursUnavailableTimesHint: "Times you cannot select are outside the restaurant opening hours for {{orderType}} orders on the selected date.",
    deliveryAndPickupOrders: "Delivery And Pickup Orders",
    orderId: "OrderID",
    orderStatus: "Order Status",
    waiter: "Waiter",
    fromCustomerApp: "From customer App",
    orderType: "Order Type",
    payByLink: "Pay By Link",
    sendDelivery: "Send Delivery",
    updateDelivery: "Update Delivery",
    requestCourier: "Request courier",
    sendCourierRequest: "Send courier request",
    sentToCourier: "Sent to courier",
    callCourier: "Call courier",
    somethingWentWrong: "Something went wrong",
    noPickupTimeProvidedForThisOrder: "No pickup time provided for this order",
    pickupTimeCalculationForThisOrderFailed: "The pickup time calculation for this order failed",
    itemEditFailed: "Item edit failed",
    thisItemCannotBeEdited: "This item cannot be edited.",
    problemInReadingItemEssentialDataMessage: "There was a problem reading essential item information"
};

export default en;
